import React from 'react'
import PropTypes from 'prop-types'
import ProgressBar from '../elements/ProgressBar'
import moment from 'moment'

class BarChart extends React.Component {
    render () {
        const Title = () => {
            if (this.props.data.type === 'value') {
                return (
                    <span>
                        <span className='bold'>{this.props.data.title}</span>
                        <span className='desktop'><span className='bold'>:</span> {this.props.data.usagePercentage}% {this.props.isDataBank ? 'available' : 'used'}</span>
                    </span>
                )
            }

            if (this.props.data.type === 'date') {
                if (this.props.isUnlimited) {
                    return (
                        <span className='bold'>
                            Days
                        </span>
                    )
                }
			    return (
                    <span className='bold'>
        {this.props.data.daysLeftInCurrentBillingCycleText}<span className='d-none d-lg-inline regular'> ({this.props.data.billingCycleProgressPercentage}%)</span>
    </span>
                )
            }

            return ''
        }

        const Usage = () => {
            if (this.props.data.type === 'value' && this.props.data.summaryText) {
                return this.props.data.summaryText.replace('/', ' / ')
            }

            return (this.props.data.type === 'date' && !this.props.isUnlimited) ? this.props.data.nextBillingCycleStart : this.props.data.daysLeftInCurrentBillingCycleText.replace( /[^\d.]/g, '' ) + " days left"
        }

        const Progress = () => {
            let progress = 0

            if (this.props.data.type === 'value') {
                progress = this.props.data.usagePercentage
            }

            if (this.props.data.type === 'date') {
                if (this.props.isUnlimited) {
                    progress = 100 - (this.props.data.daysLeftInCurrentBillingCycleText.replace(/[^\d.]/g, '') / moment().daysInMonth()) * 100
                } else {
                    progress = this.props.data.billingCycleProgressPercentage
                }
            }

            return Math.round(progress)
        }

        return (
            <div className='bar-chart-wrapper'>
                <div className='row mb-2'>
                    <div className='col-12 col-lg-8 mb-1 mb-lg-0'>
                        {Title()}
                    </div>
                    <div className='col-6 col-lg-4 text-lg-right'>
                        <span>{Usage()}</span>
                    </div>
                    <div className='col-6 d-lg-none text-right'>
                        {Progress()}%{this.props.data.type !== 'date' ? (this.props.isDataBank ? ' available' : ' used') : ''}
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12'>
                        <ProgressBar progress={Progress()} isDateField={this.props.data.type === 'date'} isDataBank={this.props.isDataBank} />
                    </div>
                </div>
            </div>
        )
    }
}

BarChart.propTypes = {
    data: PropTypes.shape({
        type: PropTypes.oneOf(['value', 'date']),
        title: PropTypes.string,
        summaryText: PropTypes.string,
        usagePercentage: PropTypes.number,
        daysLeftInCurrentBillingCycleText: PropTypes.string,
        nextBillingCycleStart: PropTypes.string,
        billingCycleProgressPercentage: PropTypes.number
    }).isRequired,
    isDataBank: PropTypes.bool
}

export default BarChart



// WEBPACK FOOTER //
// ./resources/js/components/BarChart.js